export const TescheLogo = ({ className = "h-14" }) => (
    <svg
        viewBox="0 0 300 64"
        className={className}
        data-testid="tesche-logo"
        role="img"
        aria-label="TESCHE"
    >
        <defs>
            <linearGradient id="tesche-inf" x1="0" y1="0" x2="1" y2="0">
                <stop offset="0" stopColor="#FACC15" />
                <stop offset="1" stopColor="#3B82F6" />
            </linearGradient>
        </defs>
        <circle cx="26" cy="32" r="19" fill="none" stroke="url(#tesche-inf)" strokeWidth="8" />
        <circle cx="58" cy="32" r="19" fill="none" stroke="url(#tesche-inf)" strokeWidth="8" />
        <text
            x="92"
            y="40"
            fontFamily="Changa, sans-serif"
            fontWeight="800"
            fontStyle="italic"
            fontSize="36"
            fill="#FACC15"
            letterSpacing="2"
        >
            TESCHE
        </text>
        <text
            x="95"
            y="58"
            fontFamily="JetBrains Mono, monospace"
            fontWeight="600"
            fontSize="10"
            fill="#60A5FA"
            letterSpacing="5"
        >
            MAKE DIFFERENT
        </text>
    </svg>
);
